import React, {Component} from 'react';
import {AppOutline, MessageFill, MessageOutline, UnorderedListOutline, UserOutline} from "antd-mobile-icons";
import {Badge, TabBar} from "antd-mobile";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import routes from "../../routes";

function Home(props:any) {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const setRouteActive = (value: string) => {
    navigate(value)
  }
  const tabs = [
    {
      key: '/home/index',
      title: '首页',
      icon: <AppOutline />,
      badge: Badge.dot,
    },
    {
      key: '/home/my',
      title: '我的',
      icon: <UserOutline />,
    },
  ]


    return (
      <div style={{position: 'absolute',top:0,left:0,right:0,bottom:0}}>
        <Outlet />
        <div style={{position:'absolute',bottom:0,left:0,right:0,borderTop:'1px solid rgb(223 223 223)'}}>
        <TabBar activeKey={pathname} onChange={setRouteActive}>
          {tabs.map(item => (
            <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
          ))}
        </TabBar>

        </div>
      </div>
    );
}

export default Home;
